import { BookLocation } from 'types';

/**
 * @method getPreviousLocationFromCurrentPercentage
 */
const getPreviousLocationFromCurrentPercentage = (
  previousPercentage,
  document,
  currentPercentage,
) => {
  let previousBookLocation;

  if (
    currentPercentage === 0 ||
    (previousPercentage === 0 && currentPercentage === 0)
  ) {
    if (document.previous) {
      previousBookLocation = new BookLocation({
        document: document.previous,
        percentageOfDocument: 1,
      });
    } else {
      // if there is no document.previous, we are at the beginning of the book
      // this is expected, scrub bar navigation disables the arrow button in this case
      previousBookLocation = undefined;
    }
  } else {
    previousBookLocation = new BookLocation({
      document,
      percentageOfDocument: previousPercentage,
    });
  }

  return previousBookLocation;
};

export default getPreviousLocationFromCurrentPercentage;
